module.exports = __webpack_public_path__ + "static/img/voice-close.e36e9d48.png";